<template>
<div class="chapter">
<div class="inner_page">
      ﻿

	
		<title>Collection of Sand: Essays</title>
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<h2 class="EB04MainHead" id="page_xvii">A Note on the Text</h2>
<p class="EB02BodyTextFullOut" id="col0000086">The essays in parts I, II and III were all
			published in <em>la Repubblica</em> between 1980 and 1984, apart from the following:
			‘Collection of Sand’ (<em>Corriere della Sera</em>, 25 June 1974);
			‘How New the New World Was’ (a spoken commentary for broadcast by RAI-TV,
			December 1976); ‘The Encyclopedia of a Visionary’ (<em>FMR</em>, vol. I,
			March 1982).</p>
<p class="EB03BodyTextIndented" id="col0000087">The fourth part, ‘The Shape of
			Time’, includes pieces on Japan and Mexico, from 1976, partly published in
				<em>Corriere della Sera</em> and partly unpublished, and passages on Iran that have
			never been published before, from notes made during a journey there in 1975.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// noteontext.vue?716e77bc